export default "__VITE_ASSET__CUcybeff__ 100w";